import * as types from '../../../../constants/ActionNameConstants';

export const forgotPasswordRequest = (payload) => {
  return {
    type: types.FORGOT_PASSWORD_REQUEST,
    payload,
  };
};

export const forgotPasswordSuccess = (payload) => ({
  type: types.FORGOT_PASSWORD_SUCCESS,
  payload,
});

export const forgotPasswordFailure = (error) => ({
  type: types.FORGOT_PASSWORD_FAILED,
  error,
});
